import {
  Pagination,
  PaginationContainer,
  PaginationNext,
  PaginationPage,
  PaginationPageGroup,
  PaginationPrevious,
  PaginationSeparator,
  usePagination,
} from "@ajna/pagination";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import {
  Box,
  HStack,
  IconButton,
  Skeleton,
  Text,
  useDisclosure,
  useToast,
  // useToast,
  VStack,
} from "@chakra-ui/react";
// import { CircularProgress } from "@material-ui/core";
import Loadlogo from "assets/svg/btmlogo.svg";
import { ReactComponent as Delete } from "assets/svg/delete.svg";
import { ReactComponent as Edit } from "assets/svg/edit.svg";
import { ReactComponent as Hide } from "assets/svg/hide.svg";
import { ReactComponent as Show } from "assets/svg/view.svg";
import Button from "components/Button/Button";
import P2PListingItem from "components/P2PListingItem/P2PListingItem";
import ListingFilter from "components/ListingFilter/ListingFilter";
import ConfirmationModal from "components/Modals/p2p/Confirmation";
// import ConfirmationModal from "components/Modals/p2p/Confirmation";
import ListingPreview from "components/Modals/p2p/ListingPreview";
import { isDev } from "config/constant";
import { isEmpty } from "lodash";
import Pusher from "pusher-js";
import { useEffect, useMemo, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import useState from "react-usestateref"; /// visit this later.
import {
  useCancelTradeMutation,
  // useCancelTradeMutation,
  useGetListingQuery,
  useHideListingMutation,
  // useHideListingMutation,
} from "services/p2pApi";
import { useStore } from "store";
import { clamp, lessThanSomeMinutesAgo, maybePluralize } from "util/utils";
import { transformListingToState } from "../P2pv2Edit";

// import uniq from "lodash/uniq";
import toPrecision from "util/toPrecision";

// import { useGetRateQuery } from "services/rateApi";

const channelName = "p2p";
const minimumListingsLengthOnUpdate = 6;
const maximumListingsLength = 10;

const P2pv2buy = ({ searchParams, userData }) => {
  const currentCancelVerb = useRef();
  const history = useHistory();
  const toast = useToast();
  const p2pStream = useRef();
  // const currentCancelVerb = useRef();
  const { store } = useStore();
  const onListingPage = useRef(true);
  const lastRefetch = useRef(new Date().toISOString());

  const { isOpen, onOpen, onClose } = useDisclosure();

  const [
    hideListing,
    {
      isLoading: isHiding,
      isSuccess: isHidingSuccess,
      isError: ishidingError,
      error: hidingError,
    },
  ] = useHideListingMutation();

  const [cancelTrade, { isLoading: isCancelling, isSuccess, isError, error }] =
    useCancelTradeMutation();

  const {
    isOpen: isPreviewOpen,
    onOpen: onPreviewOpen,
    onClose: onPreviewClose,
  } = useDisclosure();

  const [listing, setListing] = useState({ trades: [] });

  const [tradeToPreview, setTradeToPreview] = useState("");

  const params = useMemo(
    () => new URLSearchParams(searchParams.toString()),
    [searchParams]
  );

  const [selectedTradeId, setSelectedTradeId] = useState(null);

  const coin = params.has("coin")
    ? params.get("coin") === "all"
      ? ""
      : params.get("coin")
    : "";

  /// ,tradeOption.unitCost%3Adesc,totalCost%3Adesc
  const sortBy = useMemo(
    () =>
      params.has("coin") && params.get("coin") === "all"
        ? "createdAt%3Adesc"
        : "price%3Adesc",
    [params]
  );

  const [filterPath, setFilterPath] = useState(
    `/?page=1&limit=10&adsStatus=open&adsType=selling&sortBy=${sortBy}&coins=${coin}`
  );

  const [filterParams, setFilterParams] = useState({
    endpoint: "",
    qs: `page=1&limit=10&adsStatus=open&adsType=selling&sortBy=createdAt%3Adesc&coins=${coin}`,
  });

  const {
    data: _listing,
    isLoading: isListingLoading,
    isFetching: isListingFetching,
    isUninitialized,
    refetch,
  } = useGetListingQuery(filterPath);

  console.log("LISTING", _listing);

  // const coins = useMemo(
  //   () =>
  //     uniq(
  //       listing?.trades?.map((t) => {
  //         const noise = ["cusd", "usdt", "usdt-tron"];
  //         return !noise.includes(t?.coin) ? t.coin : "";
  //       })
  //     ).join(","),
  //   [listing]
  // );

  // const { data, isLoading } = useGetRateQuery(coins);
  // console.log(
  //   "COINS",
  //   uniq(
  //     listing?.trades?.map((t) => {
  //       const noise = ["cusd", "usdt", "usdt-tron"];
  //       return !noise.includes(t?.coin) ? `${t.coin}usd` : "";
  //     })
  //   ).join(",")
  // );

  const listingToPreview = useMemo(
    () => listing?.trades?.find((tr) => tr._id === tradeToPreview),
    [tradeToPreview, listing]
  );

  const initP2PPusherAuth = async (trades) => {
    if (!p2pStream.current) {
      const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
        authEndpoint: `${process.env.REACT_APP_API_ENDPOINT}/p2p/realtime/auth`,
        cluster: process.env.REACT_APP_PUSHER_CLUSTER,
        auth: {
          params: { channelName },
          headers: { authorization: store.token },
        },
      });
      p2pStream.current = pusher.subscribe(channelName);

      p2pStream.current?.bind("listing-sell-new", (data) => {
        try {
          let listingss = trades || listing?.trades || [];
          if (listingss.length < maximumListingsLength) {
            setListing({
              trades: [data].concat(listingss).slice(0, maximumListingsLength),
            });
          }
        } catch (err) {
          console.log({ err });
        }
      });

      p2pStream.current?.bind("listing-update", (data) => {
        try {
          const currentId = data?._id;
          if (currentId) {
            let listingss = trades || listing?.trades || [];
            const matchingListing = listingss?.findIndex(
              (l) => l._id === currentId
            );
            if (matchingListing >= 0) {
              listingss[matchingListing] = data;
              setListing({ trades: listingss });
            }
          }
        } catch (err) {
          console.log({ err });
        }
      });

      p2pStream.current.bind("listing-remove", (data) => {
        const currentId = data?._id;
        if (currentId) {
          const listingss = trades || listing?.trades || [];
          let matchingListing = listingss.findIndex((l) => l._id === currentId);
          if (matchingListing >= 0) {
            const newListings = listingss.filter((l) => l._id !== currentId);
            if (onListingPage.current) {
              if (newListings.length < minimumListingsLengthOnUpdate) {
                window.location.reload();
              }
            }
            setListing({ trades: newListings });
          }
        }
      });

      p2pStream.current.bind("reloadP2PListingPage", (data) => {
        if (data?.action === "listingsOffline")
          setListing((p) => ({
            trades: Array.isArray(p.trades)
              ? p.trades.filter((pt) => pt.userId !== data?.userId)
              : [],
          }));
        if (data?.action === "listingsOnline") {
          const refetchAllowed = !lessThanSomeMinutesAgo(
            lastRefetch.current,
            2
          );
          if (currentPage === 1 && refetchAllowed) {
            lastRefetch.current = new Date().toISOString();
            refetch();
          }
        }
      });

      if (isDev) {
        p2pStream.current?.bind("test-event", (data) => {
          try {
          } catch (err) {}
        });
      }
    } else {
    }
  };

  useEffect(() => {
    if (!isListingLoading && !isListingFetching) {
      setListing(_listing);
      initP2PPusherAuth(_listing?.trades);
    }
    // eslint-disable-next-line
  }, [_listing, isListingLoading, isListingFetching]);

  useEffect(() => {
    return () => {
      p2pStream.current && p2pStream.current.unsubscribe(channelName);
    };
    // eslint-disable-next-line
  }, []);

  console.log(
    "LISITING PREVIEW DATA",
    listingToPreview,
    transformListingToState(listingToPreview)
  );

  const {
    pages,
    pagesCount,
    offset,
    currentPage,
    setCurrentPage,
    isDisabled,
    pageSize,
  } = usePagination({
    total: listing?.totalCount,
    limits: {
      outer: 1,
      inner: 1,
    },
    initialState: {
      pageSize: 10,
      isDisabled: false,
      currentPage: 1,
    },
  });

  const handlePageChange = (nextPage) => {
    setCurrentPage(nextPage);
    const searchQuery = new URLSearchParams(filterParams?.qs);
    searchQuery.set("page", nextPage);
    const path = `${filterParams.endpoint}/?${searchQuery.toString()}`;
    // console.log("SEARCH QUERY", path);
    setFilterPath(path);
  };

  const handleApplyFilter = (path, params = null) => {
    setFilterPath(path);
    params && setFilterParams(params);
    console.log("FILTER PATH", path);
  };

  const isOwn = useMemo(() => filterPath?.includes("own"), [filterPath]);

  useEffect(() => {
    if (isSuccess) {
      toast({
        position: "bottom-right",
        title: "Success",
        description: "Listing cancelled successfully",
        status: "success",
        duration: 9000,
        isClosable: true,
      });

      onClose && onClose();
    }
    if (isError && error) {
      console.log("CANCEL LISTING ERROR", error);
      toast({
        position: "bottom-right",
        title: "Oops!!",
        description:
          error?.data?.error ??
          "Unable to cancel your listing, please try again",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  }, [isSuccess, isError, error, onClose, toast]);

  useEffect(() => {
    if (isHidingSuccess) {
      toast({
        position: "bottom-right",
        title: "Success",
        description:
          currentCancelVerb.current === "hide"
            ? "Listing hidden successfully"
            : "Listing is now visible",
        status: "success",
        duration: 4000,
        isClosable: true,
      });

      onClose && onClose();
    }
    if (hidingError && ishidingError) {
      toast({
        position: "bottom-right",
        title: "Oops!!",
        description:
          hidingError?.data?.error ??
          (currentCancelVerb.current === "hide"
            ? "Unable to hide listing, please try again"
            : "Failed to unhide listing"),
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  }, [isHidingSuccess, hidingError, ishidingError, onClose, toast]);

  return (
    <>
      <div>
        <ListingFilter
          type="buy"
          limit={pageSize}
          page={currentPage}
          onApply={handleApplyFilter}
          resetPage={() => setCurrentPage(1)}
          isLoading={isListingFetching}
          refetch={refetch}
          params={searchParams}
          country={userData.country}
        />

        {!isListingLoading && !isUninitialized ? (
          <Box
            className="p2p-box3"
            p="1.5em 0 0em 1.5em"
            borderRadius="16px 16px 0 0"
          >
            <div className="p2p-box3-top">
              <p>Seller</p>
              <p>Price</p>
              <p>Coin Amount</p>
              <p>Payment</p>
            </div>
            <div className="p2-line"></div>
            {!isEmpty(listing?.trades) &&
              listing?.trades?.map((trade) => (
                <P2PListingItem
                  key={trade._id || Math.random() * 7676767665453}
                  isFetching={isListingFetching}
                  isOwn={isOwn}
                  refetch={refetch}
                  currentUser={userData}
                  previewData={transformListingToState(trade)}
                  {...trade}
                />
              ))}

            {isEmpty(listing?.trades) && (
              <VStack py="80px">
                <Text>No Listing found</Text>
                <Link to={`/dashboard/p2p/create?${params.toString()}`}>
                  <button className="p2p2-btn1"> Create listing </button>
                </Link>
              </VStack>
            )}
          </Box>
        ) : (
          <div>
            <div className="loading-logo hide-m" id="loadlogo">
              <img src={Loadlogo} alt="loading" />
            </div>
          </div>
        )}
        {!isListingLoading ? (
          <div className="p2p-box3-m">
            {listing?.trades.length >= 1 &&
              listing?.trades.map((trades) => (
                <div
                  className="p2p-box3-items-m"
                  key={trades._id || Math.random() * 7676767665453}
                >
                  <div className="p2-box3-m-left">
                    <Skeleton
                      isLoaded={!isListingFetching}
                      maxH={isListingFetching ? "30px" : "fit-content"}
                    >
                      <div className="p2-seller">
                        <HStack>
                          <p className="p2-seller-name">
                            @{trades.userData?.username}
                          </p>

                          {isOwn && (
                            <HStack>
                              <IconButton
                                variant="ghost"
                                size="xs"
                                aria-label="edit button"
                                icon={<Box boxSize="16px" as={Edit} />}
                                _focus={{
                                  shadow: "0 0 0 3px var(--focusColor)",
                                }}
                                onClick={(e) =>
                                  history.push(
                                    `/dashboard/p2p/${trades?._id}/edit?step=pricing`
                                  )
                                }
                              />
                              <IconButton
                                variant="ghost"
                                size="xs"
                                aria-label="show trade button"
                                isLoading={isHiding}
                                disabled={isHiding}
                                icon={
                                  <Box
                                    boxSize="16px"
                                    as={trades?.hide ? Hide : Show}
                                  />
                                }
                                _focus={{
                                  shadow: "0 0 0 3px var(--focusColor)",
                                }}
                                onClick={async (_e) => {
                                  // if (isHiding) return;
                                  currentCancelVerb.current = trades?.hide
                                    ? "unhide"
                                    : "hide";
                                  // listingToHide.current = _id;
                                  await hideListing({
                                    tradeId: trades?._id,
                                    visibility: trades?.hide
                                      ? "unhide"
                                      : "hide",
                                  });
                                  refetch();
                                }}
                              />
                              <IconButton
                                variant="ghost"
                                size="xs"
                                aria-label="edit button"
                                icon={<Box boxSize="16px" as={Delete} />}
                                _focus={{
                                  shadow: "0 0 0 3px var(--focusColor)",
                                }}
                                onClick={() => {
                                  onOpen();
                                  setSelectedTradeId(trades?._id);
                                }}
                              />
                            </HStack>
                          )}
                        </HStack>

                        <div className="p2-seller-btm">
                          <p>
                            {Number(
                              Number(
                                trades?.ratingsRef?.combinedTrades || 0
                              ).toFixed(2)
                            )}{" "}
                            {maybePluralize(
                              Number(trades?.ratingsRef?.combinedTrades || 0),
                              "trade",
                              "s"
                            )}
                          </p>
                          <p>
                            {Number(
                              Number(
                                trades?.ratingsRef?.combinedRating?.average || 0
                              ).toFixed(2)
                            )}{" "}
                            <span style={{ fontSize: 10 }}>⭐</span>
                          </p>
                        </div>
                      </div>
                    </Skeleton>
                    <Skeleton
                      isLoaded={!isListingFetching}
                      maxH={isListingFetching ? "30px" : "fit-content"}
                    >
                      <div className="p2-limit-m">
                        <p>Range</p>
                        <p>
                          {/* {" "}
                          {`${
                            trades?.tradeOption?.minimumFilling ?? 0
                          } ${String(trades.sourceUnit).toUpperCase()} - ${
                            trades?.tradeOption?.maximumFilling ??
                            Number(
                              Number(
                                trades?.currentVolume?.$numberDecimal
                              ).toFixed(8)
                            )
                          } ${String(trades.sourceUnit).toUpperCase()}`} */}
                          {toPrecision(
                            trades?.tradeOption?.minimumFilling ?? 0,
                            trades?.sourceUnit
                          )}{" "}
                          -{" "}
                          {toPrecision(
                            trades?.currentVolume?.$numberDecimal ?? 0,
                            trades?.sourceUnit
                          )}
                        </p>
                      </div>
                    </Skeleton>
                    <Skeleton
                      isLoaded={!isListingFetching}
                      maxH={isListingFetching ? "30px" : "fit-content"}
                    >
                      <div className="p2-price-m">
                        <p>Price</p>
                        <p>
                          {" "}
                          {Number(
                            trades.totalCost?.$numberDecimal
                          ).toLocaleString()}{" "}
                          <span>
                            {String(trades.destinationUnit).toUpperCase()}
                          </span>
                        </p>
                      </div>
                    </Skeleton>
                  </div>
                  <div className="p2-box3-m-right">
                    <Skeleton
                      isLoaded={!isListingFetching}
                      maxH={isListingFetching ? "30px" : "fit-content"}
                    >
                      <div className="p2-limit-m">
                        <p>Available</p>
                        <p>
                          {/* 0.00010154 BTC */}
                          {/* {Number(
                            trades.volume.$numberDecimal
                          ).toLocaleString()}{" "}
                          {String(trades.sourceUnit).toUpperCase()} */}

                          {toPrecision(
                            trades.volume.$numberDecimal ?? 0,
                            trades?.sourceUnit
                          )}
                        </p>
                      </div>
                    </Skeleton>
                    <Skeleton
                      isLoaded={!isListingFetching}
                      maxH={isListingFetching ? "30px" : "fit-content"}
                    >
                      <div className="p2-payment-m">
                        <p>Payment</p>
                        <p>
                          <div className="p2-payment-optBoxes0">
                            {trades?.paymentOption?.map((payment) => (
                              <div
                                className="p2-payment-OptBox"
                                key={
                                  payment.addressRef ||
                                  Math.random() * 7676767665453
                                }
                              >
                                {payment.receivingIntoLabel === "Changera" && (
                                  <p className="pay-blue text-sm c-w">
                                    {payment.receivingIntoLabel}
                                  </p>
                                )}
                                {payment.receivingIntoLabel ===
                                  "Bitmama Wallet" && (
                                  <p className="green text-sm bit-w">
                                    {payment.receivingIntoLabel}
                                  </p>
                                )}
                                {payment.receivingIntoLabel !== "Changera" &&
                                  payment.receivingIntoLabel !==
                                    "Bitmama Wallet" && (
                                    <p className="pay-yellow text-sm ba-w">
                                      Bank Transfer
                                    </p>
                                  )}
                              </div>
                            ))}
                          </div>
                        </p>
                      </div>
                    </Skeleton>
                    <div>
                      <Skeleton
                        isLoaded={!isListingFetching}
                        maxH={isListingFetching ? "30px" : "fit-content"}
                        maxW={isListingFetching ? "120px" : "fit-content"}
                      >
                        {/* <button className="p2-buy-btn">Buy</button> */}
                        {trades.userId !== userData?.userId && (
                          <button
                            onClick={() =>
                              history.push(`/dashboard/p2p/${trades._id}/buy`)
                            }
                            className="p2-buy-btn"
                          >
                            Buy
                          </button>
                        )}

                        {trades.userId === userData?.userId && (
                          <Button
                            minW="120px"
                            maxW="120px"
                            maxH="40px"
                            fontWeight="normal"
                            bg="transparent"
                            border="2px solid #03A438"
                            color="#03A438"
                            onClick={() => {
                              setTradeToPreview(trades._id);
                              onPreviewOpen();
                            }}
                          >
                            View Ad
                          </Button>
                        )}
                      </Skeleton>
                    </div>
                  </div>
                </div>
              ))}
            {listing?.trades?.length < 1 && (
              // <div className="p2p-box3-items">
              // <div className="p2p2-nores">
              //   <p>No listings found </p>
              //   <Link to="/dashboard/p2p/create">
              //     <button className="p2p2-btn1 "> Create listing </button>
              //   </Link>
              // </div>
              // </div>
              <VStack py="40px">
                <Text>No Listing found</Text>
                <Link to={`/dashboard/p2p/create?${params.toString()}`}>
                  <button className="p2p2-btn1"> Create listing </button>
                </Link>
              </VStack>
            )}
          </div>
        ) : (
          <div>
            {/* <div className="loading-logo hide-web" id="loadlogo">
              <img src={Loadlogo} alt="loading" />
            </div> */}
          </div>
        )}

        <ListingPreview
          title="View Listing"
          state={transformListingToState(listingToPreview)}
          onConfirm={() => onPreviewClose()}
          isOpen={isPreviewOpen}
          // isLoading={isLoading}
          onClose={onPreviewClose}
          buttonText={["Close", "Close"]}
        />

        {!isListingLoading && listing?.trades?.length > 0 && (
          <Box className="paginate-box" mt="-1em !important">
            <HStack
              bg="white"
              p="10px 40px"
              justifyContent="space-between"
              borderRadius="0px 0px 16px 16px"
              flexDir={["column", "row"]}
              w="100%"
              mt="0 !important"
            >
              <Text>
                Showing {offset + 1} to{" "}
                {clamp(offset + pageSize, pageSize, listing?.totalCount ?? 0)}{" "}
                of {listing?.totalCount ?? 0}
              </Text>
              <HStack>
                <Pagination
                  pagesCount={pagesCount}
                  currentPage={currentPage}
                  isDisabled={isDisabled}
                  onPageChange={handlePageChange}
                >
                  <PaginationContainer
                    align="center"
                    justify="space-between"
                    p={4}
                    w="full"
                  >
                    <PaginationPrevious
                      mr="8px"
                      boxSize="32px"
                      _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                      _active={{ bg: "transparent" }}
                      _hover={{
                        bg: "transparent",
                      }}
                      bg="transparent"
                    >
                      <ChevronLeftIcon />
                    </PaginationPrevious>
                    <PaginationPageGroup
                      isInline
                      align="center"
                      separator={
                        <PaginationSeparator
                          border="1px solid #DFE3E8"
                          bg="transparent"
                          fontSize="sm"
                          boxSize="32px"
                          jumpSize={4}
                          _active={{ bg: "transparent" }}
                          _hover={{
                            bg: "transparent",
                          }}
                          _focus={{
                            borderColor: "transparent",
                            shadow: "0 0 0 3px var(--focusColor)",
                          }}
                        />
                      }
                    >
                      {pages.map((page) => (
                        <PaginationPage
                          boxSize="32px"
                          bg="transparent"
                          border="1px solid #DFE3E8"
                          key={`pagination_page_${
                            page || Math.random() * 7676767665453
                          }`}
                          page={page}
                          fontSize="sm"
                          _active={{ bg: "transparent" }}
                          _hover={{
                            bg: "transparent",
                          }}
                          _focus={{
                            borderColor: "transparent",
                            shadow: "0 0 0 3px var(--focusColor)",
                          }}
                          _current={{
                            borderColor: "transparent",
                            bg: "#03a438",
                            fontSize: "sm",
                            boxSize: "32px",
                            color: "white",
                            _hover: {
                              borderColor: "#DFE3E8",
                              bg: "transparent",
                              color: "black",
                            },
                          }}
                        />
                      ))}
                    </PaginationPageGroup>
                    <PaginationNext
                      ml="8px"
                      boxSize="32px"
                      _active={{ bg: "transparent" }}
                      _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                      _hover={{
                        bg: "transparent",
                      }}
                      bg="transparent"
                    >
                      <ChevronRightIcon />
                    </PaginationNext>
                  </PaginationContainer>
                </Pagination>
              </HStack>
            </HStack>
          </Box>
        )}

        <ConfirmationModal
          isOpen={isOpen}
          onClose={onClose}
          isLoading={isCancelling}
          onConfirm={() => cancelTrade(selectedTradeId)}
          title="Confirm"
          buttonText={["No", "Yes, Cancel"]}
        >
          <VStack>
            <Text textAlign="center">
              Are you sure you want to cancel this listing?
            </Text>
          </VStack>
        </ConfirmationModal>
      </div>
    </>
  );
};

export default P2pv2buy;
